import React, { useContext, useState } from 'react';
import '../service/service.css';
import Card from './Card';
import Contact from '../Contact/Contact';
import Footer from '../Footer/Footer';
import { DataContext } from '../contextAPI';
import housingLocation from '../images/housingLocation.png';
import towerdata from '../images/towerdata.png';
import pokemon from '../images/pokemon.png';

const Service = () => {
	const { toggleMode } = useContext(DataContext);
	const [navigateTo, setNavigateTo] = useState('works');
	console.log(navigateTo, 'navigateTo');

	return (
		<div className={`${toggleMode ? 'theme' : 'dark-mode'}`}>
			<div
				className={`skills-text about-me ${toggleMode ? 'theme' : 'dark-mode'}`}
				id="Services">
				<h2 className="my-skills about-me">Projects</h2>
			</div>
			<div className="cards-wrapper section">
				<Card
					image={pokemon}
					cardTitle={'Pokemon App'}
					body={
						'The Pokemon app is a user-friendly web application designed for browsing and exploring information about various Pokemon creatures.'
					}
					visit={'https://rihal-frontend-challenge.vercel.app/'}
				/>

				<Card
					image={housingLocation}
					cardTitle={'Housing Location'}
					body={
						'	The Housing Location App transforms home searching by displaying available residences in desired areas. It enables easy exploration, filtering, and access to detailed property information, enhancing the house-hunting experience.'
					}
				/>
				<Card
					image={towerdata}
					cardTitle={'Tower Data'}
					body={
						'The Tower Data Visualization Dashboard offers comprehensive insights into tower data through visual tables and charts. It empowers effective analysis and interpretation for users'
					}
				/>
			</div>

			<div
				className={`skills-text about-me ${
					toggleMode ? 'theme' : 'dark-mode'
				}`}>
				<h2 className="my-skills about-me">Contact</h2>
			</div>
			<div className="contact-box">
				<Contact />
			</div>
			<div>
				<Footer />
			</div>
		</div>
	);
};

export default Service;
